import React, { useMemo, useState } from "react";
import { Button, Drawer } from "antd";
import { Agent } from "../../../../interfaces/agent.interface";
import { agentAddress, filterAgents } from "./agentSearch";

const ICONS = "/iceholidays-assets/images/icons";

interface Props {
  agents: Agent[];
  loading?: boolean;
  value?: number;
  onChange?: (agentId?: number) => void;
}

export default function AgentPicker({ agents, loading, value, onChange }: Props) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState<number | undefined>(value);
  const [query, setQuery] = useState("");

  const selected = agents.find((a) => a.id === value);

  const visibleAgents = useMemo(() => filterAgents(agents, query), [agents, query]);

  const openSheet = () => {
    setDraft(value);
    setQuery("");
    setOpen(true);
  };

  const handleDone = () => {
    onChange?.(draft);
    setOpen(false);
  };

  return (
    <>
      <button type="button" className="customize-tour-form__select-trigger" onClick={openSheet}>
        <span>{selected ? selected.name : "Please Select"}</span>
        <img src={`${ICONS}/icon-ctf-chevron-down.svg`} alt="" aria-hidden="true" />
      </button>

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        placement="bottom"
        height="calc(100dvh - 64px)"
        closable={false}
        title="Preferred Travel Agent"
        extra={
          <button type="button" className="customize-tour-agent-sheet__close" aria-label="Close" onClick={() => setOpen(false)}>
            <img src={`${ICONS}/icon-ctf-close.svg`} alt="" aria-hidden="true" />
          </button>
        }
        footer={
          <Button type="primary" block className="customize-tour-form__btn-continue" onClick={handleDone}>
            Done
          </Button>
        }
        rootClassName="customize-tour-agent-sheet"
      >
        <label className="customize-tour-agent-sheet__search">
          <img src={`${ICONS}/icon-ctf-search.svg`} alt="" aria-hidden="true" />
          <input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search city, area"
            aria-label="Search agents by city or area"
          />
        </label>

        <div className="customize-tour-agent-sheet__list" role="radiogroup" aria-label="Preferred travel agent">
          {loading && <p className="customize-tour-agent-sheet__empty">Loading agents...</p>}
          {!loading && visibleAgents.length === 0 && <p className="customize-tour-agent-sheet__empty">No agents found.</p>}
          {visibleAgents.map((agent) => {
            const isSelected = agent.id === draft;
            return (
              <button
                key={agent.id}
                type="button"
                role="radio"
                aria-checked={isSelected}
                className={`customize-tour-agent-sheet__card${isSelected ? " customize-tour-agent-sheet__card--selected" : ""}`}
                onClick={() => setDraft(agent.id)}
              >
                <span className={`customize-tour-form__option-check${isSelected ? " is-selected" : ""}`}>
                  {isSelected && <span className="customize-tour-form__option-check-dot" />}
                </span>
                <span className="customize-tour-agent-sheet__logo">
                  {agent.image && <img src={agent.image} alt="" />}
                </span>
                <span className="customize-tour-agent-sheet__info">
                  <span className="customize-tour-agent-sheet__name">{agent.name}</span>
                  <span className="customize-tour-agent-sheet__address">{agentAddress(agent)}</span>
                </span>
              </button>
            );
          })}
        </div>
      </Drawer>
    </>
  );
}
